<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
      >
        <el-form-item label="字段名" required prop="field_name">
          <el-input v-model="form.field_name"/>
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import {
  editFeedBack,
  updateFeedBack,
  storeFeedBack,
  createFeedBack,
} from '@/api/feed-backs'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        field_name: '',
      },
      errors: {},
    }
  },
  methods: {
    async getData() {
      let data

      if (this.editMode) {
        ({ data } = await editFeedBack(this.resourceId))
        this.fillForm(data)
      } else {
        ({ data } = await createFeedBack())
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateFeedBack(this.resourceId, this.form)
      } else {
        await storeFeedBack(this.form)
      }
    },
  },
}
</script>

<style scoped lang="scss">
</style>
